<template>
	<el-dialog title="转接" :visible.sync="dialogContent">
		<!--转接弹窗-->
		<div class="model-search">
			<el-dropdown class="dropmenu" @command="handleCommand">
				<el-button type>
					{{selectedName}}
					<i class="el-icon-arrow-down el-icon--right"></i>
				</el-button>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item
						:command="item.key"
						:key="index"
						v-for="(item,index) in searchKey"
					>{{item.name}}</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<el-input placeholder="请输入内容" v-model="search" clearable>
				<input type="text" autocomplete="off" placeholder="请输入内容" />
			</el-input>
			<div class="clear"></div>
		</div>
		<div class="custom_list">
			<div class="section" v-for="item in transferUsersData" @click="clickRow(item)">
				<div class="avatar">
					<img :src="item.headImg" />
					<span :class="item.onAccess==false?'avatarTagRed':'avatarTag'">{{item.stateName}}</span>
				</div>
				<div class="infor">
					<div class="ename">{{item.nickName}}</div>
					<div class="number">工号：{{item.account}}</div>
				</div>
				<div class="infor pinpai">
					<div class="ename"></div>
					<div class="number">品牌：{{item.channelTag.map(d=>d.channelName).join('、')}}</div>
				</div>
				<div class="current infor">
					<div class="ename"></div>
					<div class="number">当前服务人数：{{item.accessCount}}人</div>
				</div>
				<div class="choose">
					<i class="el-icon-success" style="color:#5cb6ff;" v-if="item.selected==true"></i>
				</div>
				<div class="clear"></div>
			</div>
		</div>
		<el-input type="textarea" :rows="2" placeholder="备注" v-model="remarks" resize="none" class="note"></el-input>
		<span slot="footer" class="dialog-footer">
			<el-button @click="dialogContent = false">取 消</el-button>
			<el-button type="primary" @click="confirmTransferOrder">确认转单</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: 'transitionModeBox',
	data() {
		return {
			dialogContent: false,
			search: '',
			transferUsersData: [],
			data: [],
			remarks: '',
			searchKey: [
				{
					key: 'account',
					name: '工号'
				},
				{
					key: 'nickName',
					name: '客服昵称'
				},
				{
					key: 'channelTag',
					name: '客服品牌'
				}
			],
			selectedName: '工号',
			selectedKey: 'account'
		}
	},
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		transferUsers: {
			type: Array,
			default: []
		}
	},
	watch: {
		visible: function(val) {
			this.dialogContent = val
		},
		transferUsers: function(val) {
			let arr = []
			val.forEach(item => {
				var obj = new Object()
				obj.headImg = item.headImg
				obj.account = item.account
				obj.nickName = item.nickName
				obj.accessCount = item.accessCount
				obj.channelTag = item.channelTags
				obj.selected = false
				obj.conversationId = item.conversationId
				obj.onAccess = item.onAccess
				obj.stateName = item.stateName
				obj.currentStateId = item.currentStateId
				arr.push(obj)
			})
			this.transferUsersData = arr
			this.data = arr
		},
		dialogContent: function(val) {
			if (!val) {
				this.$emit('onClose', false)
				this.remarks = ''
			}
		},
		search: function(val) {
			let vm = this
			if (val != undefined && val != '') {
				this.transferUsersData = vm.transferUsersData.filter(data =>
					data[vm.selectedKey]
						.toLowerCase()
						.includes(vm.search.toLowerCase())
				)
			} else {
				this.transferUsersData = this.data
			}
		}
	},
	methods: {
		handleCommand(val) {
			let vm = this
			let obj = vm.searchKey.find(d => d.key == val)
			vm.selectedKey = val
			vm.selectedName = obj.name
			// .filter(data => !search || data[selectedKey].toLowerCase().includes(search.toLowerCase()))
		},
		clickRow(item) {
			let vm = this
			if (!item.onAccess) {
				this.$message({
					showClose: true,
					message: `当前状态为${item.stateName},不可转接！`,
					type: 'warning'
				})
				return
			}
			let index = vm.transferUsersData.findIndex(
				d => d.account == item.account
			)
			let obj = vm.transferUsersData[index]
			vm.transferUsersData.forEach(d => {
				if (d.account != obj.account) {
					d.selected = false
				}
			})
			vm.transferUsersData[index].selected = !obj.selected
		},
		confirmTransferOrder() {
			let vm = this
			let model = vm.transferUsersData.find(d => d.selected == true)
			if (model == undefined) {
				this.$confirm('请选中需要转接的客服人员', '提示', {
					confirmButtonText: '确定',
					type: 'warning',
					showCancelButton: false
				})
				return
			}
			let obj = new Object()
			obj.conversationId = model.conversationId
			obj.remarks = vm.remarks
			this.$emit('confirmTransferOrder', obj)
			this.remarks = ''
		}
	}
}
</script>
<style scoped>
.custom_list {
	margin-top: 30px;
	max-height: 300px;
	/* overflow-y: auto; */

	overflow-y: auto;
}
.section {
	padding: 10px 0;
	border-bottom: 1px solid #ddd;
}
.note {
	margin-top: 50px;
}
.choose {
	float: right;
	margin-top: 10px;
}
.el-icon-success {
	cursor: pointer;
}
.el-icon-success:before {
	font-size: 35px;
}
.avatar {
	width: 60px;
	height: 60px;
	float: left;
	position: relative;
}
.avatar img {
	width: 60px;
	height: 60px;
	border-radius: 50%;
}
.avatarTag {
	position: absolute;
	width: 25px;
	height: 15px;
	line-height: 15px;
	font-size: 10px;
	border-radius: 10px;
	background-color: #5abc5c;
	text-align: center;
	color: #fff;
	bottom: 0;
	left: 50%;
	margin-left: -10px;
}
.avatarTagRed {
	position: absolute;
	width: 25px;
	height: 15px;
	line-height: 15px;
	font-size: 10px;
	border-radius: 10px;
	background-color: red;
	text-align: center;
	color: #fff;
	bottom: 0;
	left: 50%;
	margin-left: -10px;
}
.infor {
	float: left;
	margin-left: 30px;
}
.infor .ename {
	line-height: 25px;
	font-size: 10px;
	margin-top: 10px;
	height: 25px;
}
.infor .number {
	line-height: 25px;
	font-size: 10px;
}
.pinpai {
	float: left;
	margin-left: 60px;
}
.current {
	margin-left: 60px;
}
</style>


// WEBPACK FOOTER //
// src/components/customer/talks/transitionModeBox.vue